/* eslint-disable no-unused-vars */

import {globalConfig} from '../../Config/config';
import {CSEntriesMapped} from '../constants/CSclientMapping';
import ContentStack from 'contentstack';

const CSStack = () => {
  const {DELIVERY_TOKEN, APIKEY, ENV, REGION} = globalConfig._config.ContentStack;
  return ContentStack.Stack({
    api_key: APIKEY,
    delivery_token: DELIVERY_TOKEN,
    environment: ENV,
    region: REGION,
  });
};

const getEntryWithRef = (ctUid, ref, locale, tenant_identity) => {
  return new Promise((resolve, reject) => {
    const query = CSStack()
      .ContentType(ctUid)
      .Query()
      .language(locale)
      .includeReference(ref)
      .includeOwner()
      .toJSON();
    let tenant = CSStack().ContentType('tenant').Query().where('tenant_identity', tenant_identity);
    const data = query.referenceIn('tenant', tenant).find();
    data.then(
      (result) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      },
    );
  });
};

const getEntry = (ctUid, locale, tenant_identity) => {
  return new Promise((resolve, reject) => {
    const query = CSStack().ContentType(ctUid).Query().language(locale).includeOwner().toJSON();
    let tenant = CSStack().ContentType('tenant').Query().where('tenant_identity', tenant_identity);
    const data = query.referenceIn('tenant', tenant).find();
    data.then(
      (result) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      },
    );
  });
};
const getSpecificEntry = (ctUid, entryUrl, locale) => {
  return new Promise((resolve, reject) => {
    const blogQuery = CSStack().ContentType(ctUid).Query().language(locale).includeOwner().toJSON();
    const data = blogQuery.where('url', `${entryUrl}`).find();
    data.then(
      (result) => {
        resolve(result[0]);
      },
      (error) => {
        reject(error);
      },
    );
  });
};

const getSpecificEntryWithRef = (ctUid, entryUrl, ref, locale) => {
  return new Promise((resolve, reject) => {
    const blogQuery = CSStack()
      .ContentType(ctUid)
      .Query()
      .language(locale)
      .includeReference(ref)
      .includeOwner()
      .toJSON();
    const data = blogQuery.where('url', `${entryUrl}`).find();
    data.then(
      (result) => {
        resolve(result[0]);
      },
      (error) => {
        reject(error);
      },
    );
  });
};

const setEntries = async () => {
  const tenant_identity = globalConfig._config.client.CStenantID;
  const lang = globalConfig._config.client.CSlang;
  const fetchEntries = async () => {
    let allEntriesData = {};
    for (let i = 0; i < CSEntriesMapped.length; i++) {
      const content = CSEntriesMapped[i];
      if (content.refs.length) {
        const entryWithRef: any = await getEntryWithRef(
          content.name,
          content.refs,
          lang,
          tenant_identity,
        );
        allEntriesData[content.name] = entryWithRef[0][0];
      } else {
        const entry: any = await getEntry(content.name, lang, tenant_identity);
        allEntriesData[content.name] = entry[0][0];
      }
    }
    return allEntriesData;
  };

  const allEntriesData = await fetchEntries();
  return allEntriesData;
};

export {setEntries, getSpecificEntry, getSpecificEntryWithRef};
